import React from "react";
import "./pvcReport.css";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";
import { INSPECTOR_LIST } from "../../data/inspector_data";
import { PV_CHECKLIST_STATIC } from "../../data/pvc_data";
import RemoveIcon from "@mui/icons-material/Remove";

export default function PVCReport() {
  const pvcChecklist = useSelector((state) => state.pvc_list);
  const { selectedInspectorId, formData } = useSelector(
    (state) => state.ins_info
  );

  const selectedInspector =
    INSPECTOR_LIST.find((ins) => ins.id === selectedInspectorId) || null;

  const renderCheckSymbol = (checked) => {
    if (checked === true) return <CheckIcon fontSize="small" />;
    if (checked === false) return "N/A";
    return <RemoveIcon fontSize="small" />;
  };

  return (
    <div className="pv_ccr">
      <img className="report_Logo" src="../images/uEnergy.png" alt="Logo"></img>
      <h1 className="report_title">Solar PV Commision Checklist</h1>

      {/* Basic_info_section */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Refrence No.</h1>
          <h2>{formData.manualRef}</h2>
        </li>
        <li className="table_col">
          <h1>Installation Address</h1>
          <h2>{formData.installationAddress}</h2>
        </li>
        <li className="table_col">
          <h1>Completed By</h1>
          <h2>{selectedInspector.name}</h2>
          <h1 className="dateTab">Date</h1>
          <h2>{formData.date}</h2>
        </li>
      </ul>

      {/* section_info */}
      <p className="sec_info">
        As per the Solar PV Code of Practice (IET), the below is a commissioning
        checklist for the d.c. circuit of a grid-connected PV system. The a.c.
        circuit should be inspected and tested in accordance with BS 7671 and
        supporting documents, in the same manner as any other a.c. circuit.
        <br></br>
        <br></br>
        The DNO may require further commissioning procedures. We should ensure
        all relevant testing and commissioning actions have been completed
        before handing over the system to the customer.
        <br></br>
        <br></br>
        Testing should be performed in the sequence indication. In the event of
        any testing producing a fault, all previous steps in the sequence should
        be repeated once the fault is corrected.
      </p>

      {/* first_commision_table */}
      {PV_CHECKLIST_STATIC.map((section, idx) => (
        <ul className="table_sec2" key={idx}>
          <li className="subHead">{section.title}</li>

          {/* HEADER */}
          <li className="table_col">
            <h1>Item</h1>
            <h2>Requirements</h2>
          </li>

          {/* SUBSECTIONS */}
          {section.subsections.map((sub, sIdx) => (
            <li className="info_col" key={sIdx}>
              <h1>{sub.subtitle}</h1>

              <div className="point_sec">
                {sub.items.map((it, iIdx) => {
                  const checked = pvcChecklist[it.key]; // <-- new logic
                  return (
                    <div className="sub_info" key={iIdx}>
                      <h3>{it.label}</h3>
                      <h2 style={{ color: "gray" }}>
                        {renderCheckSymbol(checked)}
                      </h2>
                    </div>
                  );
                })}
              </div>
            </li>
          ))}
        </ul>
      ))}

      {/* Report_info_section */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Signed</h1>
          <h2>{selectedInspector.name}</h2>
        </li>
        <li className="table_col">
          <h1>Date</h1>
          <h2>{formData.date}</h2>
        </li>
      </ul>
    </div>
  );
}
